import React, {  useReducer } from 'react';
import { enrich_tag_validator } from '../../../lib/tag_validators';

import ActionButton, { SquaredButton } from '../../builder/ActionButton';
import ButtonCollection from '../../builder/ButtonCollection';
import Input from '../../builder/Input';
import { queryCache } from 'react-query';

import TagRules from './TagRules';
import { fields_by_type } from '../../account/TagValidators';
import ContentSelector from '../../Form/ContentSelector';

const reducer = (state, action) => {
	switch(action.type) {
		case 'SET_TAG':
			return {
				...state,
				tag_id:action.payload,
				tag_field:false,
			};
		case 'SET_FIELD':
			return {
				...state,
				tag_field:action.payload,
			};

		case 'SET_TEXT':
			return {
				...state,
				text:action.payload,
			};

		default:
			return state;
	}
};

const OcrTagEnrichment = ({ condition, validation_tags }) => {
	const type = (['quantity_article'].includes(condition.type)) ? 'article' : condition.type;
	const close = ContentSelector.useCloseAction();

// invalidate and force refetch a query

	const [ state, dispatch ] = useReducer(reducer, {
		tag_id:false,
		tag_field:false,
		text:"",
	});

	if(!state.tag_id) {
		const refinable_tags = validation_tags.filter((t) => {
			if(t.OcrTag.type != type) return false;
			return (condition.match.includes(t.OcrTag.id)) ? true : false;
		});

		return (
			<ButtonCollection style={{ marginBlockStart:'0.9em' }}>
				{refinable_tags.map((tag) => (
					<ActionButton
						key={`btn_${tag.OcrTag.id}`}
						onClick={() => dispatch({ type:'SET_TAG', payload:tag.OcrTag.id })}
					>{tag.OcrTag.name}</ActionButton>
				))}
			</ButtonCollection>
		)
	}

	const tag = validation_tags.find((t) => t.OcrTag.id == state.tag_id);

	if(!state.tag_field && ['store', 'location'].includes(tag.OcrTag.type)) {
		return (
			<ButtonCollection style={{ marginBlockStart:'0.9em' }}>
				{fields_by_type[tag.OcrTag.type].map((field) => (
					<ActionButton
						key={`btn_${field.k}`}
						onClick={() => dispatch({ type:'SET_FIELD', payload:field.k })}
					>{field.v}</ActionButton>
				))}
			</ButtonCollection>
		)
	}

	return (
		<div class="edit_field">
			<div style={{ flexGrow:'1' }}>
				<TagRules
					tag={tag}
				/>

				<div class="fields_list level">
					<div class="row_level">
						<div class="l">Text to match:</div>

						<div class="v">
							<Input
								name='value'
								value={state.text}
								change={(k, v) => dispatch({ type:'SET_TEXT', payload:v })}
								_class={{ first:true }}
							/>
						</div>

						<ButtonCollection>
							<SquaredButton
								icon='knk-on greenButton'
								color='white'
								onClick={() => {
									enrich_tag_validator(state.tag_id, state.text,state.tag_field, () => {
										queryCache.refetchQueries('validation_tags');
										close();
									});
								}}
							/>
						</ButtonCollection>
					</div>
				</div>
			</div>
		</div>
	)
};

export default OcrTagEnrichment;